export default class FaqDelivery {
    async handle() {
        const DeliveryQuestions = await require(`@/content/${process.env.VUE_APP_COUNTRY_ISO}/${process.env.VUE_APP_I18N_LOCALE}/faqs/answers/signup/delivery.json`);
        // const DeliveryQuestions = import('@/content/AUT/de/faqs/answers/signup/delivery.json').then(module => module.default);

        return DeliveryQuestions;
    }
}
